import React from 'react'
import { Stack } from '@hub/stack'
import { ProductDeck } from '@scentregroup/shared/hub-components/product-deck'
import { SGPageTemplateProduct } from '../../../../../../../src/types/page-templates'
import { useAnalyticsImpressionTracker } from '@scentregroup/shared/analytics-observer/analytics-impression-tracker-context'

export interface IRelatedProductsProps {
  title: string
  recommendations: SGPageTemplateProduct[]
  analytics: {
    indexName: string
  }
}

const RelatedProducts: React.FunctionComponent<
  React.PropsWithChildren<IRelatedProductsProps>
> = ({ title, recommendations, analytics: { indexName } }) => {
  const { trackProductListViewedEvent } = useAnalyticsImpressionTracker()
  if (recommendations.length === 0) {
    return null
  }
  const products = recommendations.map(product => ({
    ...product,
    viewItem: () => {
      trackProductListViewedEvent(product, {
        listId: `Product Reel Automated (${title})`,
      })
    },
  }))

  return (
    <Stack
      sx={{
        marginTop: 'spacing-4xl',
        marginLeft: { base: '-spacing-lg', md: '-spacing-2xl' },
        marginRight: { base: '-spacing-lg', md: '-spacing-2xl' },
      }}
      data-insights-index={indexName}
      as="div"
    >
      <ProductDeck title={title} products={products} />
    </Stack>
  )
}

export default RelatedProducts
